import React from 'react'
import { t } from 'ttag'

import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { DocumentsTable } from './common/DocumentsTable/DocumentsTable'

import { useSearch } from 'hooks'

const Documents = () => {
  const [search, setSearch] = useSearch()

  return (
    <Pane tagName="article">
      <Pane.Header title={t`Documents`}>
        <SearchWidget query={search} onChange={setSearch} />
      </Pane.Header>
      <DocumentsTable search={search} />
    </Pane>
  )
}

export default Documents
